import { useQuery } from '@tanstack/react-query';
import type {
  ActivePerDayResponse,
  AlertDayDetailResponse,
  AlertPipelineResponse,
} from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

export function useActivePerDay(days: number = 7, customerId?: number | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['alert-overview', 'active-per-day', days, customerId],
    queryFn: async () => {
      const params = new URLSearchParams({ days: days.toString() });
      if (customerId) params.set('customerId', customerId.toString());
      return await apiClient.get<ActivePerDayResponse>(
        `alert-overview/active-per-day?${params}`,
      );
    },
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useAlertDayDetail(day: string | null, customerId?: number | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['alert-overview', 'day-detail', day, customerId],
    queryFn: async () => {
      const params = new URLSearchParams({ day: day! });
      if (customerId) params.set('customerId', customerId.toString());
      return await apiClient.get<AlertDayDetailResponse>(
        `alert-overview/day-detail?${params}`,
      );
    },
    enabled: !!day,
  });
}

export function useAlertPipeline(days: number = 7, customerId?: number | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['alert-overview', 'pipeline', days, customerId],
    queryFn: async () => {
      const params = new URLSearchParams({ days: days.toString() });
      if (customerId) params.set('customerId', customerId.toString());
      return await apiClient.get<AlertPipelineResponse>(
        `alert-overview/pipeline?${params}`,
      );
    },
    refetchInterval: 5 * 60 * 1000,
  });
}
